export const durationUnits = [
  {label: 'Seconds', value: 'seconds'},
  {label: 'Minutes', value: 'minutes'},
  {label: 'Hours', value: 'hours'},
  {label: 'Days', value: 'days'},
]


export const defaultRateLimit = {
  duration: '1 minutes',
  limit: 5,
}

export const requestTypes = [
  "AutoComplete", "Create"
]

export const defaultRateLimits = (availableRequestTypes = requestTypes) => {
  const request = availableRequestTypes[0]
  return ({
    request: request,
    limits: [defaultRateLimit],
    dirty: []
  })
}